import { useMutation } from 'react-query';
import axios from 'axios';
import { useContext } from 'react';
import { TerminalAppearanceAPI } from '../../../constants/API';
import { multipartHeaders } from '../../../constants/HeadersAPI';
import { AlertContext } from '../../../context/AlertProvider';
import { AlertType } from '../../../types/enums';
import { defaultSuccessMessage } from '../../../constants/alertText';
import { TerminalButtonMedia } from '../../../types/Admin/TerminalAppearanceTypes';

export const usePostTabloSliderImage = () => {
  const context = useContext(AlertContext);

  const { mutate: uploadTabloSliderImage, isLoading: isUploadTabloSliderImageLoading } =
    useMutation(
      ['TerminalAppearanceUploadTabloSliderImage'],
      (file: File) => {
        const formData = new FormData();
        formData.append('file', file);
        return axios.post<TerminalButtonMedia>(
          TerminalAppearanceAPI.uploadTabloSliderImage,
          formData,
          multipartHeaders()
        );
      },
      {
        onSuccess: () => {
          context?.setAlert({ type: AlertType.Success, message: defaultSuccessMessage });
        }
      }
    );

  return { uploadTabloSliderImage, isUploadTabloSliderImageLoading };
};
